import styled from '@emotion/styled';
import { MobileBreakpoint } from '@utils/consts/breakpoints.consts';

export const FormWrapper = styled.div<{
  isVisible?: boolean;
  brandName?: boolean;
}>`
  display: ${props => (props.isVisible ? 'block' : 'none')};
  width: 100%;
  ${props =>
    props.brandName &&
    `
    form span.MuiTypography-root {
      font-weight: 400;
    }
    form > div:first-of-type > div:nth-of-type(4) {
      grid-column: span 6 / span 3;
       @media screen and (max-width: ${MobileBreakpoint}px) {
        grid-column: span 12 / span 3;
      }
    }
  `};
`;
